import './VideoTileAdminControls.scss'

import DeleteDialog from 'lib/components/admin/DeleteDialog/DeleteDialog'
import UploadVideoButton from 'lib/components/admin/UploadVideoButton/UploadVideoButton'
import Button from 'lib/components/Button/Button'
import getFilenameFromPath from 'lib/util/getFilenameFromPath'
import ControlButton from 'pages/Home/admin/ControlButton/ControlButton'
import VideoType from 'pages/Home/VideoType'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import DeleteVideoDialog from './DeleteVideoDialog'
import EditVideoDialog from './EditVideoDialog'
import UploadThumbnailDialog from './UploadThumbnailDialog'

export interface VideoTileAdminControlsProps {
  video: VideoType
}

export default function VideoTileAdminControls(props: VideoTileAdminControlsProps): JSX.Element {
  const { video } = props
  const [isEditThumbnailDialogOpen, setIsEditThumbnailDialogOpen] = useState(false)
  const [isDeleteThumbnailDialogOpen, setIsDeleteThumbnailDialogOpen] = useState(false)
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false)
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [t] = useTranslation()

  const openEditDialog = () => setIsEditDialogOpen(true)
  const closeEditDialog = () => setIsEditDialogOpen(false)
  const openDeleteDialog = () => setIsDeleteDialogOpen(true)
  const closeDeleteDialog = () => setIsDeleteDialogOpen(false)

  const onEditThumbnail = () => {
    closeEditDialog()
    setIsEditThumbnailDialogOpen(true)
  }

  const onDeleteThumbnail = () => {
    closeEditDialog()
    setIsDeleteThumbnailDialogOpen(true)
  }

  function renderNotReady() {
    return (
      <div className="video-tile-admin-controls__not-ready">
        <div>{t('home.videosSection.admin.videoTile.processing')}</div>
        <Button variant="link" onClick={() => window.location.reload()}>
          {t('home.videosSection.admin.videoTile.refresh')}
        </Button>
      </div>
    )
  }

  const isReady = video.upload && video.upload.videoKey

  return (
    <div>
      {!isReady && renderNotReady()}
      {isReady && (
        <UploadVideoButton
          style={{ bottom: '45px', left: '10px' }}
          videoId={video.id}
          videoUploadId={video.upload.id}
        />
      )}
      {isReady && <ControlButton onClick={openEditDialog} style={{ top: '10px', left: '10px' }} />}
      <ControlButton variant="delete" onClick={openDeleteDialog} style={{ top: '10px', right: '10px' }} />
      {isEditDialogOpen && (
        <EditVideoDialog
          onRequestClose={closeEditDialog}
          video={video}
          onDeleteThumbnail={onDeleteThumbnail}
          onEditThumbnail={onEditThumbnail}
        />
      )}
      {isDeleteDialogOpen && <DeleteVideoDialog onRequestClose={closeDeleteDialog} video={video} />}
      {isEditThumbnailDialogOpen && (
        <UploadThumbnailDialog onRequestClose={() => setIsEditThumbnailDialogOpen(false)} video={video} />
      )}
      {isDeleteThumbnailDialogOpen && (
        <DeleteDialog
          name={getFilenameFromPath(video.thumbnailKey)}
          url={`${process.env.THREESIXTY_TRAINING_URI}/admin/videos/${video.id}/thumbnail`}
          onRequestClose={() => setIsDeleteThumbnailDialogOpen(false)}
        />
      )}
    </div>
  )
}
